// Mirrors the five bonus PDFs actually delivered with SALSA & BACHATA READY™ (Impultienda store).
export const bonuses: Array<{
  title: string;
  text: string;
  items: string[];
  benefit: string;
}> = [{
  title: 'Warm-Ups That Build Musicality',
  text: 'Printable warm-up drills that cue timing, rhythm awareness, and musical phrasing — so students start dancing with the music, not against it.',
  items: ['Timing and counting warm-ups', 'Rhythm awareness drills', 'Musical phrasing cues', 'Printable warm-up cards'],
  benefit: 'Students start dancing with the music, not against it.'
}, {
  title: 'Partnerwork Connection Drills',
  text: 'Step-by-step partner exercises for frame, lead-and-follow basics, timing, and communication.',
  items: ['Frame and connection drills', 'Lead-and-follow basics', 'Partner timing exercises', 'Communication practice'],
  benefit: 'Less confusion. More reliable technique.'
}, {
  title: 'Progress Check Templates',
  text: 'Simple tools you can use to evaluate skills, spot gaps fast, and assign the right next practice.',
  items: ['Skill evaluation templates', 'Teacher observation sheets', 'Gap-spotting checklists', 'Next-practice planning'],
  benefit: 'Consistent week-to-week improvement.'
}, {
  title: 'Dance Class Energizers & Icebreakers',
  text: '30 quick activities to build confidence, connection, and fun — for welcoming students, energizing a class, and resetting attention.',
  items: ['Five-minute class openers', 'Mid-class energy resets', 'Closing and reflection activities', 'No-touch and solo alternatives'],
  benefit: 'Never walk into class without a plan again.'
}, {
  title: 'Salsa & Bachata Practice Night – Teacher’s Social Dance Event Kit',
  text: 'A 20-page kit to host relaxed, inclusive practice nights where students apply what they already know.',
  items: ['Event formats and planning timeline', 'Studio setup and floor map', 'Practice round cards and partner rotation', 'Printable studio signs and checklists'],
  benefit: 'Students build confidence for the social dance floor.'
}];
